import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=43045761&scoped=true&"
import script from "./forward.vue?vue&type=script&lang=js&"
export * from "./forward.vue?vue&type=script&lang=js&"
import style0 from "./forward.vue?vue&type=style&index=0&id=43045761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43045761",
  null
  
)

export default component.exports